export default __webpack_public_path__ + "assets/images/cv.5355115.pdf";